import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from './../layout/layout.module';
import { ExchangeCardComponent } from './exchange-card/exchange-card.component';
import { ExchangeCartItemComponent } from './exchange-cart-item/exchange-cart-item.component';
import { ExchangeCartComponent } from './exchange-cart/exchange-cart.component';
import { ExchangeListComponent } from './exchange-list/exchange-list.component';
import { ExchangeSidebarComponent } from './exchange-sidebar/exchange-sidebar.component';
import { ExchangeComponent } from './exchange.component';
import { ExchangeQueryResolve } from './exchange.resolve';
import { CancelComponent } from './exchange-card/cancel/cancel.component';
import { CancelModalService } from './exchange-card/cancel/cancel-modal.service';

@NgModule({
  imports: [CommonModule, SharedModule, LayoutModule],
  declarations: [
    ExchangeListComponent,
    ExchangeSidebarComponent,
    ExchangeComponent,
    ExchangeCardComponent,
    ExchangeCartComponent,
    ExchangeCartItemComponent,
    CancelComponent
  ],
  entryComponents: [CancelComponent],
  providers: [ExchangeQueryResolve, CancelModalService]
})
export class ExchangeModule {}
